// removed by extract-text-webpack-plugin
module.exports = {"sliderWrapper":"src-components-slider-__style-module___sliderWrapper","disabled":"src-components-slider-__style-module___disabled","ripple":"src-components-slider-__style-module___ripple","sliderBar":"src-components-slider-__style-module___sliderBar","sliderValue":"src-components-slider-__style-module___sliderValue","triangles":"src-components-slider-__style-module___triangles","triangleUR":"src-components-slider-__style-module___triangleUR","triangleDR":"src-components-slider-__style-module___triangleDR"};


//////////////////
// WEBPACK FOOTER
// ./src/components/slider/style.module.css
// module id = 1794
// module chunks = 0